import styled from 'styled-components';

export const Image = styled.img`
  width: 184px;
  height: 112px;
  margin: var(--s-10) 0;
`;
